import React from 'react';

import isArchived from 'archive/isArchived';
import navigateToURL from 'lib/navigateToURL';
import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import fuzzydate from 'util/fuzzydate';

import {TemplateCollectionListingGraphQL} from '../../../../graphql-fragments/notebook/templates/__generated/TemplateCollectionListingGraphQL';

interface CollectionSidepanelItemProps {
  isActive: boolean;
  isCompact: boolean;
  collection: TemplateCollectionListingGraphQL;
  isChild: boolean;
}

export default function CollectionSidepanelItem(props: CollectionSidepanelItemProps): JSX.Element {
  const {isActive, isCompact, collection, isChild} = props;
  const date = fuzzydate(collection.modifiedAt, {compact: isCompact, showTime: false});
  const subtitle = `${isCompact ? '' : 'Modified '}${date}`;
  const title = collection.name;
  const icon = <BenchlingIcon icon="collection" />;

  return (
    <SidepanelItem
      active={isActive}
      className="sidepanelItem--noIcon"
      faded={isArchived(collection)}
      icon={icon}
      isCompact={isCompact}
      onClick={() => {
        navigateToURL(collection.url);
      }}
      parties={[{...collection.ownerJson}]}
      subTitle={subtitle}
      title={{
        text: title,
        node: <span>{title}</span>,
      }}
      tooltipText=""
      isExpandable={false}
      isChild={isChild}
    />
  );
}
